namespace Matrix.Data {
    export namespace DataReportsService {
        export const baseUrl = 'Data/DataReports';

        export declare function Create(request: Serenity.SaveRequest<DataReportsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<DataReportsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DataReportsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<DataReportsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListParameters(request: DataReportListParametersRequest, onSuccess?: (response: Serenity.ListResponse<DataParameter>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListColumns(request: DataReportListColumnsRequest, onSuccess?: (response: Serenity.ListResponse<DataReportColumn>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListSheets(request: DataReportListSheetsRequest, onSuccess?: (response: Serenity.ListResponse<string>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExecuteReport(request: DataReportExecuteRequest, onSuccess?: (response: Serenity.ListResponse<{ [key: string]: any }>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExecuteReportWorkbook(request: DataReportExecuteRequest, onSuccess?: (response: HtmlResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetCustomDate(request: GetCustomDateRequest, onSuccess?: (response: GetCustomDateResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetViewerModel(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DataReportViewerModel>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Data/DataReports/Create",
            Update = "Data/DataReports/Update",
            Delete = "Data/DataReports/Delete",
            Retrieve = "Data/DataReports/Retrieve",
            List = "Data/DataReports/List",
            ListParameters = "Data/DataReports/ListParameters",
            ListColumns = "Data/DataReports/ListColumns",
            ListSheets = "Data/DataReports/ListSheets",
            ExecuteReport = "Data/DataReports/ExecuteReport",
            ExecuteReportWorkbook = "Data/DataReports/ExecuteReportWorkbook",
            GetCustomDate = "Data/DataReports/GetCustomDate",
            GetViewerModel = "Data/DataReports/GetViewerModel"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ListParameters', 
            'ListColumns', 
            'ListSheets', 
            'ExecuteReport', 
            'ExecuteReportWorkbook', 
            'GetCustomDate', 
            'GetViewerModel'
        ].forEach(x => {
            (<any>DataReportsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
